<template>
    <form id="app">
        <div class="card rounded-0 mb-3 mt-4">
            <h3 class="card-header">
                {{ title }}
            </h3>
            <div class="card-body">
                <div class="form-group">
                    <div class="row">
                        <label for="Email" class="col-4 d-flex align-self-center justify-content-end">
                            Email
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input for="Email" v-model="content.email" v-bind:disabled="!allowEmailEdit" class="form-control" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.email.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.email.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Company" class="col-4 d-flex align-self-center justify-content-end">
                            Company
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input id="Company" v-model="content.company" class="form-control" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.company.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.company.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="FirstName" class="col-4 d-flex align-self-center justify-content-end">
                            First Name
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input id="FirstName" v-model="content.firstname" class="form-control" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.firstname.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.firstname.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="LastName" class="col-4 d-flex align-self-center justify-content-end">
                            Last Name
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <input id="LastName" v-model="content.lastname" class="form-control" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.lastname.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.lastname.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="Industry" class="col-4 d-flex align-self-center justify-content-end">
                            Industry
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="Industry" v-model="content.industryId" class="form-control">
                                <option value="" disabled>-- Select Industry --</option>
                                <option v-for="industryItem in sourcevalues.industries" v-bind:key="industryItem.text" :value="industryItem.value">
                                    {{industryItem.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.cadTool.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.cadTool.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="CadTool" class="col-4 d-flex align-self-center justify-content-end">
                            Preferred CAD Tool
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="CadTool" v-model="content.cadTool" class="form-control">
                                <option value="" disabled>-- Select CAD Tool --</option>
                                <option v-for="cadItem in sourcevalues.cadTools" v-bind:key="cadItem.text" :value="cadItem.value">
                                    {{cadItem.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.cadTool.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.cadTool.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="CountryId" class="col-4 d-flex align-self-center justify-content-end">
                            Country
                            <span class="required">*</span>
                        </label>
                        <div class="col-8">
                            <select id="CountryId" v-model="content.countryId" class="form-control">
                                <option value="" disabled>-- Select Country --</option>
                                <option v-for="country in sourcevalues.countries" v-bind:key="country.text" :value="country.value">
                                    {{country.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="v$.content.countryId.$error">
                        <div class="text-danger small col-8 offset-4" v-for="error of v$.content.countryId.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row" v-if="this.sourcevalues.populated">
                        <div class="col-8 offset-4">
                            <div class="custom-control custom-checkbox">
                                <input id="toc" class="custom-control-input" v-model="content.toc" type="checkbox" />
                                <input id="tocId" v-model="content.tocId" type="hidden" />
                                <label class="custom-control-label" for="toc" v-html="this.sourcevalues.tocconsent.displayText"></label>
                            </div>
                        </div>
                        <div class="row" v-if="v$.content.toc.$error">
                            <div class="text-danger small col-8 offset-4" v-for="error of v$.content.toc.$silentErrors" :key="error.$message">
                                {{ error.$message }}
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-8 offset-4">
                            <vue-recaptcha :siteKey="recaptchaSiteKey"
                                           size="normal"
                                           theme="light"
                                           hl="en"
                                           @verify="recaptchaVerified"
                                           @expire="recaptchaExpired"
                                           @fail="recaptchaFailed"
                                           ref="vueRecaptcha">
                            </vue-recaptcha>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <input id="externalRegister" type="submit" class="btn btn-light" :disabled="v$.$invalid" value="Register" @click.prevent="postForm" />
            </div>
        </div>
    </form>
</template>

<script>
    import { mapState } from 'vuex'
    import vueRecaptcha from '@/components/recaptcha/vue-recaptcha.vue'
    import useVuelidate from '@vuelidate/core'
    import { required, email, minLength, sameAs } from '@vuelidate/validators'

    export default {
        name: 'ExternalRegisterPanel',
        components: {
            vueRecaptcha
        },
        setup() {
            return { v$: useVuelidate() }
        },
        props: {
            sourceModel: {
                type: Object,
                default: () => { }
            },
            userModel: {
                type: Object,
                default: () => { }
            },
            postMethod: {
                type: Function
            },
            allowEmailEdit: {
                type: Boolean,
                default: () => true
            },
            title: {
                type: String,
                default: () => "Complete Account Registration"
            }
        },
        data() {
            return {
                content: {
                    email: "",
                    company: "",
                    firstname: "",
                    lastname: "",
                    industryId: "",
                    cadTool: "",
                    countryId: "",
                    toc: false,
                    tocId: -1,
                    news: false,
                    recaptchaValue: null
                },
                sourcevalues: {
                    populated: false,
                    industries: [],
                    countries: [],
                    cadTools: [],
                    tocconsent: null
                },
                recaptcha: {
                    show: true,
                    valid: false,
                    value: null
                }
            }
        },
        computed: {
            ...mapState({
                recaptchaSiteKey: state => state.recaptchaSiteKey
            })
        },
        validations() {
            return {
                content: {
                    email: { required, email, $autoDirty: true },
                    company: { required, $autoDirty: true },
                    firstname: { required, $autoDirty: true },
                    lastname: { required, $autoDirty: true },
                    industryId: { required, $autoDirty: true },
                    cadTool: { required, $autoDirty: true },
                    countryId: { required, $autoDirty: true },
                    toc: {
                        selected: function (value) {
                            return value == true
                        }, $autoDirty: true
                    },
                    recaptchaValue: { required, $autoDirty: true }
                }
            }
        },
        methods: {
            //move both of these out to the view, and bind them in from there
            postForm: async function () {
                this.$emit("postForm", this.$event, this.content);
            },
            recaptchaVerified(response) {
                if (response && response != null) {
                    this.recaptcha.valid = true;
                    this.recaptcha.value = response;
                } else {
                    this.recaptcha.valid = false;
                    this.recaptcha.value = null;
                }
            },
            recaptchaExpired() {
                this.$refs.vueRecaptcha.reset();
                this.recaptcha.valid = false;
                this.recaptcha.value = null;
            },
            recaptchaFailed() {
                this.recaptcha.valid = false;
                this.recaptcha.value = null;
            }
        },
        watch: {
            'recaptcha': {
                handler: function (val) {
                    this.content.recaptchaValue = val.value;
                },
                deep: true
            },
            'sourceModel': {
                handler: function (val) {
                    this.sourcevalues = val;
                    this.content.tocId = val.tocconsent.id;
                },
                deep: true
            },
            'userModel': {
                handler: function (val) {
                    var recaptchaValue = this.content.recaptchaValue;
                    this.content = val;
                    this.content.tocId = this.sourcevalues.tocconsent.id;
                    this.content.recaptchaValue = recaptchaValue;
                }
            }
        }
    }
</script>

<style scoped>
</style>